"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import Link from "next/link";
import GroupItemWrapper from "./GroupItemWrapper";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { getTimeAgo } from "@/helpers/Helpers";
export default function GroupItem(t0) {
  const $ = _c(43);
  const {
    group,
    activeGroupId,
    onActiveGroupId
  } = t0;
  let t1;
  if ($[0] !== activeGroupId || $[1] !== group.id) {
    t1 = () => !!activeGroupId && activeGroupId === group.id;
    $[0] = activeGroupId;
    $[1] = group.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsActive = t1;
  const [isActive, setIsActive] = useState(getIsActive());
  let t2;
  if ($[3] !== getIsActive) {
    t2 = () => {
      setIsActive(getIsActive());
    };
    $[3] = getIsActive;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeGroupId) {
    t3 = [activeGroupId];
    $[5] = activeGroupId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== isActive || $[8] !== onActiveGroupId) {
    t4 = () => {
      if (!isActive || !onActiveGroupId) {
        return;
      }
      onActiveGroupId(null);
    };
    $[7] = isActive;
    $[8] = onActiveGroupId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const deActivate = t4;
  const [deactivateHover, setDeactivateHover] = useState(false);
  let t5;
  if ($[10] !== group.created_at) {
    t5 = getTimeAgo(new Date(group.created_at).getTime());
    $[10] = group.created_at;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const timeAgo = t5;
  let t6;
  if ($[12] !== deActivate || $[13] !== isActive || $[14] !== onActiveGroupId) {
    t6 = isActive && onActiveGroupId && <div className="tw-absolute -tw-right-2 -tw-top-10"><button onClick={e => {
        e.stopPropagation();
        deActivate();
      }} onMouseEnter={() => setDeactivateHover(true)} onMouseLeave={() => setDeactivateHover(false)} type="button" className="tw-group tw-p-1.5 tw-bg-iron-800 tw-border-0 tw-flex tw-items-center tw-justify-center tw-rounded-full"><span className="tw-sr-only">Remove</span><svg className="tw-h-4 tw-w-4 tw-text-iron-400 group-hover:tw-text-iron-50 tw-transition tw-duration-300 tw-ease-out" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg></button></div>;
    $[12] = deActivate;
    $[13] = isActive;
    $[14] = onActiveGroupId;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== group.created_by.pfp) {
    t7 = group.created_by.pfp ? <img className="-tw-mt-1.5 tw-flex-shrink-0 tw-object-contain tw-h-7 tw-w-7 tw-rounded-md tw-bg-iron-700 tw-ring-2 tw-ring-iron-900" src={getScaledImageUri(group.created_by.pfp, ImageScale.W_AUTO_H_50)} alt="Profile Picture" /> : <div className="-tw-mt-1 tw-flex-shrink-0 tw-object-contain tw-h-7 tw-w-7 tw-rounded-md tw-bg-iron-700 tw-ring-2 tw-ring-iron-900" />;
    $[16] = group.created_by.pfp;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = `/${group.created_by?.handle}`;
  const t9 = group.created_by?.handle;
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <span className="tw-text-iron-50 tw-font-semibold"><Link href={t8} onClick={_temp} className="tw-no-underline hover:tw-underline tw-group-hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out tw-text-iron-50 tw-text-sm tw-font-medium">{t9}</Link></span>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== timeAgo) {
    t11 = <span className="tw-text-iron-400 tw-font-normal tw-text-xs">{timeAgo}</span>;
    $[21] = timeAgo;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="tw-mt-1 tw-text-sm tw-flex tw-items-center tw-w-full tw-justify-between">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t7) {
    t13 = <div className="tw-px-3 tw-flex tw-gap-x-3">{t7}{t12}</div>;
    $[26] = t12;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== group.name) {
    t14 = <div className="tw-pt-3 tw-pb-3 tw-flex tw-flex-col tw-h-full tw-space-y-4 tw-divide-y tw-divide-solid tw-divide-x-0 tw-divide-iron-700"><div className="tw-flex-1 tw-px-3"><p className="tw-mb-0 tw-text-base tw-text-iron-50 tw-font-semibold tw-whitespace-nowrap tw-overflow-hidden tw-text-overflow-ellipsis tw-truncate">{group.name}</p></div></div>;
    $[29] = group.name;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-h-full">{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15 || $[35] !== t6) {
    t16 = <div className="-tw-mt-1 tw-bg-iron-900 tw-flex tw-flex-col tw-rounded-b-xl tw-relative ">{t6}{t15}</div>;
    $[34] = t15;
    $[35] = t6;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== deactivateHover || $[38] !== group || $[39] !== isActive || $[40] !== onActiveGroupId || $[41] !== t16) {
    t17 = <GroupItemWrapper group={group} isActive={isActive} deactivateHover={deactivateHover} onActiveGroupId={onActiveGroupId}>{t16}</GroupItemWrapper>;
    $[37] = deactivateHover;
    $[38] = group;
    $[39] = isActive;
    $[40] = onActiveGroupId;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
}
function _temp(e_0) {
  e_0.stopPropagation();
}